import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "drawer-items",
  templateUrl: "./drawer-items.component.html",
})
export class DrawerItemsComponent {

  @Input() public items: any[] = [];
  @Input() public selectedItem: any;
  @Input() public title: string = "Items";
  @Input() public openListButtonLabel: string = "Add or select Item";
  @Input() public multiselect: boolean = false;
  @Input() public showAddButton: boolean = false;
  @Input() public showEditButton: boolean = false;
  @Input() public disabled: boolean = false;
  @Input() public isClosed: boolean = true;
  @Input() public selectedItems: any[] = [];
  @Output() public itemSelected = new EventEmitter<any>();
  @Output() public itemEdition = new EventEmitter<any>();
  @Output() public askForNew = new EventEmitter<any>();

  public filter: any;
  public filterText: any;
  public filterContent: any;
  // public selectedItems: any[] = [];

  public selectItem(item: any): void {
    if (!this.disabled) {
      this.selectedItem = item;
      this.itemSelected.emit([item]);
    }
    this.closeLayer();
  }

  public isSelected(item: any): boolean {
    return this.selectedItem === item;
  }

  public isSelectedMultiple(item: any): boolean {
    return this.selectedItems.includes(item);
  }

  public selectMultipleItem(item: any): void {
    if (!this.disabled) {
      if (this.isSelectedMultiple(item)) {
        this.selectedItems = this.selectedItems.filter(i => i !== item);
      } else {
        this.selectedItems.push(item);
      }
    }
  }

  public selectAll(): void {
    if (this.selectedItems.length === this.items.length) {
      this.selectedItems = [];
    } else {
      this.selectedItems = [...this.items];
    }
  }

  public saveSelectedItems(): void {
    if (this.multiselect) {
      this.itemSelected.emit(this.selectedItems);
    } else {
      this.itemSelected.emit(this.selectedItem);
    }
    this.closeLayer();
  }

  public open(): void {
    // Logic to open the drawer or modal
    console.log("---- open drawer ----", this.items);
    this.isClosed = false;
  }

  public newItem() {
    if (!this.disabled) {
      const name = this.filterText || '';
      this.closeLayer();
      this.clearFilter();
      this.askForNew.emit(name);
    }
  }

  public closeLayer(): void {
    // Logic to close the drawer or modal
    this.isClosed = true;
  }

  public filterChanged(value: any): void {
      this.filterContent = value;
      this.filter = { name: value };
  }

  public clearFilter(): void {
      this.filter = { name: "" };
      this.filterText = "";
      this.filterContent = "";
  }
}
